import { CommonModule } from '@angular/common';
import { AfterContentInit, Component, EventEmitter, Input, NO_ERRORS_SCHEMA, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, TemplateRef, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterLink, RouterLinkActive, RouterModule, RouterOutlet } from '@angular/router';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { IconsModule, SVGIcon } from '@progress/kendo-angular-icons';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { ActionsLayout, LayoutModule, Orientation } from '@progress/kendo-angular-layout';
import { NavigationModule } from '@progress/kendo-angular-navigation';
import { LoggerService } from '../../../shared/logger.service';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { all } from '@awesome.me/kit-787edf9aa0/icons';
import { DialogModule, KENDO_DIALOGS, KENDO_WINDOW, WindowCloseResult, WindowModule, WindowRef, WindowService, WindowState } from '@progress/kendo-angular-dialog';
import { LabelModule } from '@progress/kendo-angular-label';
import { products } from './products';
import {
  userStoryFactory,
  storyStateFactory,
  storyTypeFactory,
  storyPriorityFactory
} from './user-story.data';
import { searchIcon } from '@progress/kendo-svg-icons';
import { ListViewModule } from '@progress/kendo-angular-listview';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { CurrentItemComponent } from './current-item/current-item.component';
import { BehaviorSubject, Subscription } from 'rxjs';
import { CasiEventService } from '../../casi-event.service';
import { FormModes } from '../../../common/constants.lib';
import { setTitle } from '../../../common/utils.lib';
import { UserStory, IUserStory, StoryState, StoryType, StoryPriority, User as UserModel, CasiUserStory, CasiStoryStatus, CasiStoryType, CasiStoryPriority, CasiStoryEstimate } from '../../../models/models.lib';
import { TileItem } from '../../../common/obj.lib';

@Component({
  selector: 'casi-current-iteration',
  standalone: true,
  imports: [
    CommonModule,
    LayoutModule,
    ButtonsModule,
    IndicatorsModule,
    RouterModule,
    IconsModule,
    NavigationModule,
    FormsModule,
    ReactiveFormsModule,
    DropDownsModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    WindowModule,
    LabelModule,
    ListViewModule,
    InputsModule,
    FormsModule,
    IconsModule,
    CurrentItemComponent,
    KENDO_WINDOW,
    KENDO_DIALOGS
  ],
  schemas: [NO_ERRORS_SCHEMA],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './current-iteration.component.html',
  styleUrl: './current-iteration.component.scss'
})
export class CurrentIterationComponent implements OnInit, OnDestroy, AfterContentInit, OnChanges {

  @ViewChild("appendTo", { read: ViewContainerRef }) appendTo: ViewContainerRef | undefined;

  @ViewChild(TemplateRef) windowTitleBar: TemplateRef<unknown> | undefined;

  private _tile: TileItem | undefined;
  @Input({ required: true })
  set tile(value: TileItem) {
    this.logger.debug(`set tile: `, value);
    this._tile = value;
  }
  get tile() {
    return this._tile!;
  }

  private _users: UserModel[] = [];
  @Input({ required: true }) set users(value: UserModel[]) {
    this.logger.debug(`set users: `, value);
    this._users = value;
  }
  get users() {
    return this._users;
  }

  private _userStories: CasiUserStory[] = [];
  @Input({ required: true })
  set userStories(val: CasiUserStory[]) {
    this._userStories = val;
  }
  get userStories() {
    return this._userStories;
  }

  @Input({ required: true }) public storyStatus: CasiStoryStatus[] = [];
  @Input({ required: true }) public storyTypes: CasiStoryType[] = [];
  @Input({ required: true }) public storyPriorities: CasiStoryPriority[] = [];
  @Input({ required: true }) public storyEstimates: CasiStoryEstimate[] = [];
  @Input() public selectedUserStoryId: string | null = null;

  private _showTitle = new BehaviorSubject<string>('');
  get showTitle() {
    return this._showTitle.getValue();
  }
  set showTitle(val: string) {
    this._showTitle.next(val);
  }

  public currentItem: IUserStory = <IUserStory>{};

  public formMode: FormModes = FormModes.NOTSET;

  public editWinOpen: boolean = false;

  // public userStories: UserStory[] = userStoryFactory();
  // public storyStates: StoryState[] = storyStateFactory();
  // public storyTypes: StoryType[] = storyTypeFactory();
  // public storyPriorities: StoryPriority[] = storyPriorityFactory();

  public searchIcon: SVGIcon = searchIcon;

  private _subs: Subscription[] = [];

  private _windowRef: WindowRef | undefined;

  constructor(
    private logger: LoggerService,
    public faIcons: FaIconLibrary,
    private casiEventService: CasiEventService,
    private windowService: WindowService
  ) {
    faIcons.addIcons(...all);
    // this.parentEventListener = new EventEmitter<TileItem>();
  }

  //#region Ng Event Handlers

  ngOnChanges(changes: SimpleChanges): void {
    this.logger.debug('ngOnChanges...', changes);
  }

  ngAfterContentInit(): void {
    this.logger.debug('ngAfterContentInit...');
  }
  ngOnDestroy(): void {
    this.logger.debug('ngOnDestroy...');
    this._subs.forEach(s => s.unsubscribe());
  }
  ngOnInit(): void {
    this.logger.debug('ngOnInit...', this.constructor.name);
    this.logger.debug('selectedUserStoryId', this.selectedUserStoryId);
    // this._subs.push(this.casiEventService.casiEvent$.subscribe((e) => {
    //   this.logger.debug(`ngOnInit:casiEvent: `, e);
    //   if (e.target) {
    //     this.logger.debug(`ngOnInit:casiEvent: componentName:`, e.target);
    //     this.logger.debug(`ngOnInit:casiEvent: componentName:`, e.target === this.constructor.name);
    //     if (e.target === this.constructor.name) {
    //       this.onAddClicked();
    //     }
    //   }
    // }));
  }

  //#endregion

  public onAddClicked(): void {
    this.logger.debug("onAddClicked...");
    this.currentItem = <IUserStory>{ title: 'New Title' };
    this.formMode = FormModes.NEW;
    this.logger.debug("onAddClicked:currentItem ", this.currentItem);
    this.showTitle = setTitle(this.formMode, 'User Story');
    this.editWinOpen = true;
    // this._windowRef = this.windowService.open({
    //   // titleBarContent: this.windowTitleBar,
    //   appendTo: this.appendTo,
    //   title: setTitle(this.formMode, 'User Story'),
    //   content: 'My Content!',
    //   width: 1000,
    //   minWidth: 320,
    //   height: 300
    // });
    // this._windowRef.result.subscribe(results => {
    //   this.logger.debug('showAddWindow:results: ', results);
    //   if (results instanceof WindowCloseResult) {
    //     this.closeWindowRef();
    //   }
    // });

    // this._windowRef.content.instance.closeForm.subscribe(() => {
    //   this.logger.debug('showAddWindow:closeForm');
    //   this.closeWindowRef();
    // });

  }

  public close(): void {
    this.logger.debug('close...');
    this.editWinOpen = false;
  }

  private closeWindowRef(): void {
    if (this._windowRef) {
      this._windowRef.close();
      this._windowRef = undefined;
    }
    this.editWinOpen = false;
  }

  public onDataBound(e: any): void {
    // Code to execute after items are loaded
    this.logger.debug('dataBound');
    if (this.selectedUserStoryId) {
      let ui = this.userStories.findIndex((value, index, array) => {
        this.logger.debug('val', value);
        return !this.selectedUserStoryId ? false : value.id == parseInt(this.selectedUserStoryId);
      });
      this.logger.debug('found story index', ui);
    }
  }

}
